export const NotificationType = {
    NONE: 1,
    EMAIL: 2,
    TEXT: 3,
    APPLICATION: 4,
    DEFAULT: 5
}